module.exports = __webpack_public_path__ + "./kit/docs/img/icon-net.68d3f7cf92ed893f9a677e64903afb73.svg";